import axiosInstance from "../../../utils/axiosInstance";
import { handleFrontendError } from "../../../utils/errorHandler";

export const InventoryApis = {
  fetchInventory: async () => {
    try {
      return axiosInstance.get(`/inventory`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },

  fetchOrders: async () => {
    try {
      return axiosInstance.get(`/orders`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },

  fetchCollectionByTitle: async (title) => {
    try {
      const response = await axiosInstance.get(
        `/inventory/collections/${title}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );
      return {
        data: response.data,
        success: response.status,
        status: response.status,
      };
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },

  addNewProduct: async (formDataToSend) => {
    try {
      return await axiosInstance.post(
        `/inventory/add-new-product`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        },
      );
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },

  // log raw product payload (JSON) for debugging/telemetry
  logProductPayload: async (payload) => {
    try {
      return await axiosInstance.post(`/inventory/log-payload`, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
    } catch (error) {
      return handleFrontendError(error, "Error logging product payload");
    }
  },

  updateProduct: async (productId, formDataToSend) => {
    try {
      return await axiosInstance.post(
        `/inventory/update/product/${productId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        },
      );
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },

  deleteItem: async (productId) => {
    try {
      const response = await axiosInstance.delete(
        `/inventory/delete/product/${productId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      return handleFrontendError(error, "Error");
    }
  },
};
